import { Component, OnInit, OnDestroy, Injector, ViewChild } from '@angular/core';
import { GridOptions, RowNode } from 'ag-grid';
import { AgGridSortFilterUtils } from 'app/core/ag-grid-utils/ag-grid-sort-filter-utils';
import { AgGridActionsEnum } from 'app/core/enums/ag-grid-actions.enums';
import { TabsUnverifiedTripsEnum } from 'app/core/enums/tabs-unverified-trips.enum';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { BooleanCheckComponent } from 'app/pages/A2-utils/grid-components/boolean-check/boolean-check.component';
import { DataProcessingService } from 'app/pages/data-processing/data-processing.service';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { _currencyFormat, _downloadFile } from 'app/utils/trip2-query-builder/utils/helpers';
import * as moment from 'moment';
import { Subscription } from 'rxjs/Subscription';
import { getSelectNodeAfterFilter } from '../../../../utils/helpers';
import { switchMap, tap, finalize } from 'rxjs/operators';
import { PlanService } from 'app/core/services/plan.service';
import Swal from 'sweetalert2';
import { GridLayoutStore, moduleActionIdOf } from 'app/utils/grid-layout-menu/grid-layout-store';

@Component({
  selector: 'app-encounters-grid',
  templateUrl: './encounters-grid.component.html',
  styleUrls: ['./encounters-grid.component.scss']
})
export class EncountersGridComponent extends ParentModule implements OnInit, OnDestroy {
  @ViewChild('modalReservation') modalReservation: T2CardComponent;
  observableList: Subscription[] = [];
  isCLM = JSON.parse(localStorage.getItem('isCLM'));
  isAV = JSON.parse(localStorage.getItem('isAV'));
  gridExportEncountersRejections: GridOptions;
  gridSelected: any;
  clearSortSwitch = false;
  enableClearSort = true;
  enableClearFilter = true;
  tripData: any;
  tripDataSelected: any;
  tripsArrayIds: number[];
  dataCurrentModule: any = {};
  selectedTab = TabsUnverifiedTripsEnum.ElectronicSubmissions;
  modalExportVisible = false;
  isOpenAppRidersCreate: boolean;
  showSetPlanTypeAndRegionButton = false;

  constructor(
    protected service: DataProcessingService,
    protected objSweetAlert: SweetAlertHelper,
    protected tripService: ReservationService,
    protected Inject: Injector,
    private toastrAlertHelper: ToastrAlertHelper,
    private planService: PlanService,
    private layoutStore: GridLayoutStore
  ) {
    super('app-data-processing-export', Inject);
    this.gridExportEncountersRejections = <GridOptions>{};
    this.initGrid(this.gridExportEncountersRejections);

    this.observableList.push(this.actions.asObservable().subscribe((res) => {
      this.dataCurrentModule = res;
      this.getLayout();
    }));
    this.isCLM = 1;
  }

  ngOnInit(): void {
    this.initLayoutMenu();
    this.observableList.push(
      this.service.actionGrid$.subscribe({
        next: (res) => {
          if (res && res.isSubmit) {
            let showColumns = false;
            switch (res.action) {
              case AgGridActionsEnum.LoadData:
              case AgGridActionsEnum.SaveLayout:
              case AgGridActionsEnum.ClearFilters:
              case AgGridActionsEnum.ClearSort:
                showColumns = (res.selectedTab === TabsUnverifiedTripsEnum.Rejections);
                switch (res.action) {
                  case AgGridActionsEnum.LoadData:
                    if (res && res.dataList.length) {
                      this.dataGrid(res.dataList);
                    } else {
                      this.setGrid(this.gridExportEncountersRejections);
                    }
                    break;
                  case AgGridActionsEnum.SaveLayout:
                    this.saveLayout();
                    break;
                  case AgGridActionsEnum.ClearFilters:
                    this.clearFiltersExport();
                    break;
                  case AgGridActionsEnum.ClearSort:
                    this.clearSortExport();
                    break;
                  default:
                    break;
                }
                break;
              case AgGridActionsEnum.showColumn:
              case AgGridActionsEnum.hideColumn:
                showColumns = (res.action !== AgGridActionsEnum.showColumn);
                this.setGrid(this.gridExportEncountersRejections);
                this.selectedTab = res.selectedTab;
                break;
              case AgGridActionsEnum.generateFile:
                if (res.dataList.length) {
                  const valueParameters = res.dataList[0];
                  this.generate837File(valueParameters.formIdSelected, valueParameters.isSubmitions);
                }
                break;
              case AgGridActionsEnum.duplicateTrips:
                this.gridSelected = getSelectNodeAfterFilter(this.gridExportEncountersRejections).map(item => item.tripid);
                this.setNonDuplicate(res.dataList);
                break;
              case AgGridActionsEnum.SetReservationPlanTypeAndRegion:
                this.setReservationPlanTypeAndRegion();
                break;
              default:
                break;
            }

            this.toggleGridColumn(
              this.gridExportEncountersRejections, ['errordescription', 'errortype', 'errorcode', 'icn'],
              showColumns
            );
          }
        },
        error: (er) => this.objSweetAlert.captureException(er)
      }),
      this.actionsList$.subscribe({
        next: (resp: any) => {
          if (resp && resp.length) {
            this.showSetPlanTypeAndRegionButton = resp.includes('SetPlanTypeAndRegion');
          }
        },
        error: (er) => this.objSweetAlert.captureException(er)
      })
    );
    this.getReservationGrid();
  }

  private createColumn = () => [
    {
      allowContextMenuWithControlKey: true,
      headerName: '',
      width: 48,
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true
    },
    {
      headerName: 'Error Description',
      field: 'errordescription',
      colId: 'errordescription',
      width: 200,
      hide: true
    },
    {
      headerName: 'Error Type',
      field: 'errortype',
      colId: 'errortype',
      width: 150,
      hide: true
    },
    {
      headerName: 'Error Code',
      field: 'errorcode',
      colId: 'errorcode',
      width: 200,
      hide: true
    },
    {
      headerName: 'ICN',
      field: 'icn',
      colId: 'icn',
      width: 100,
      hide: true
    },
    {
      headerName: 'Reservation',
      children: [
        {
          headerName: 'Plan Type',
          field: 'plantype',
          colId: 'plantype',
          width: 70
        },
        {
          headerName: 'Region',
          field: 'reservationregion',
          width: 70
        },
      ]
    },
    {
      headerName: 'Vehicle',
      field: 'vehiclecode',
      colId: 'vehicle',
      width: 70
    },
    {
      headerName: 'Validation',
      field: 'validations',
      colId: 'errorValid',
      width: 70,
      cellRenderer: this.getValidation,
      valueGetter: (params) => {
        if (params && params.data) {
          return this.validate(params);
        }
      }
    },
    {
      headerName: 'Trip Status',
      field: 'tripstatus',
      colId: 'status',
      width: 60
    },
    {
      headerName: 'Driver',
      field: 'drivername',
      colId: 'Driver',
      width: 150
    },
    {
      headerName: 'Last Billing Change',
      children: [
        {
          headerName: 'User',
          field: 'lastbillingfullname',
          colId: 'lastbillingfullname',
          width: 80
        },
        {
          headerName: 'Date',
          field: 'lastdateupdated',
          colId: 'lastdateupdated',
          width: 50,
          cellRenderer: (params) => {
            if (params.data.lastdateupdated) {
              return moment(params.data.lastdateupdated).format('MM-DD-YYYY hh:mm');
            }
          }
        }
      ]
    },
    {
      headerName: 'Rider Information',
      children: [
        {
          headerName: 'Rider',
          field: 'ridernameformatbilling',
          colId: 'ridername',
          width: 150
        },
        {
          headerName: 'Gender',
          field: 'ridergender',
          colId: 'ridergender',
          width: 50
        },
        {
          headerName: 'Member Id',
          field: 'ridermemberid',
          colId: 'ridermemberid',
          width: 90,
          cellStyle: {textAlign: 'center'}
        },
        {
          headerName: 'DOB',
          field: 'riderdobformat',
          colId: 'riderdob',
          width: 70
        },
        {
          headerName: 'Age',
          field: 'riderage',
          colId: 'riderage',
          width: 55,
          cellStyle: {textAlign: 'right'}
        },
        {
          headerName: 'Address',
          field: 'riderstreetaddress',
          colId: 'riderstreetaddress',
          width: 180
        },
        {
          headerName: 'City',
          field: 'ridercity',
          colId: 'ridercity',
          width: 100
        },
        {
          headerName: 'Zip',
          field: 'riderzip',
          colId: 'riderzip',
          width: 50
        },
        {
          headerName: 'County',
          field: 'ridercounty',
          colId: 'ridercounty',
          width: 70
        },
        {
          headerName: 'Region',
          field: 'riderregion',
          colId: 'riderregion',
          width: 70,
          cellStyle: {textAlign: 'right'}
        },
        {
          headerName: 'Trip Duplicate',
          field: 'ishighlighted',
          width: 80,
          cellRendererFramework: BooleanCheckComponent
        },
      ]
    },
    {
      headerName: 'R. For Transport',
      field: 'reasontransport',
      colId: 'reasontransport',
      width: 160
    },
    {
      headerName: 'Payor',
      field: 'payor',
      colId: 'payor',
      width: 80
    },
    {
      headerName: 'PU Location',
      field: 'pulocation',
      colId: 'pulocation',
      width: 100
    },
    {
      headerName: 'DO Location',
      field: 'dolocation',
      colId: 'dolocation',
      width: 100
    },
    {
      headerName: 'Payor Authorization',
      field: 'payorauthorization',
      colId: 'payorauthorization',
      width: 100
    },
    {
      headerName: 'Service',
      field: 'servicetype',
      colId: 'service',
      width: 80
    },
    {
      headerName: 'Provider',
      field: 'company',
      colId: 'company',
      width: 80
    },
    {
      headerName: 'Provider amount',
      field: 'provideramount',
      colId: 'provideramount',
      width: 100,
      cellStyle: {textAlign: 'right'},
      cellRenderer: this.amountCell
    },
    {
      headerName: 'Submission Date',
      field: 'submissiondate',
      colId: 'submissiondate',
      width: 100
    },
    {
      headerName: 'Paid Date',
      field: 'paiddate',
      colId: 'paiddate',
      width: 100
    },
    {
      headerName: 'File No',
      field: 'edifileid',
      colId: 'edifileid',
      width: 100
    },
    {
      headerName: 'File Count',
      field: 'filecount',
      colId: 'filecount',
      width: 100
    },
    {
      headerName: 'File Sent Date',
      field: 'filesentdate',
      colId: 'filesentdate',
      width: 130
    },
    {
      headerName: 'File Name',
      field: 'filename',
      colId: 'filename',
      width: 250
    },
    {
      headerName: 'Plan',
      field: 'plan',
      colId: 'plan',
      width: 250
    },
    {
      headerName: 'Company',
      field: 'broker',
      colId: 'broker',
      width: 80
    },
    {
      headerName: 'Billing Status',
      field: 'billingstatus',
      colId: 'billingstatus',
      width: 80
    },
    {
      headerName: 'Aging',
      field: 'aging',
      colId: 'aging',
      width: 90
    },
    {
      headerName: 'Remarks',
      field: 'remarks',
      colId: 'remarks',
      width: 80
    },
    {
      headerName: 'Date',
      field: 'dateofservice',
      colId: 'date',
      width: 75
    },
    {
      headerName: 'Reservation',
      field: 'consecutive',
      colId: 'consecutive',
      width: 80
    },
    {
      headerName: 'RescueNet #',
      field: 'rescuenetnumber',
      colId: 'rescuenetnumber',
      width: 80
    },
    {
      headerName: 'Leg',
      field: 'leg',
      colId: 'leg',
      width: 50
    },
    {
      headerName: 'Appointment',
      field: 'appointmenttime',
      colId: 'appointmenttime',
      width: 80
    },
    {
      headerName: 'Total amount',
      field: 'totalamount',
      colId: 'totalamount',
      width: 100,
      cellStyle: {textAlign: 'right'},
      cellRenderer: this.amountCell
    },
    {
      headerName: 'Millages',
      field: 'totalmiles',
      colId: 'totalmiles',
      width: 100,
      cellStyle: {textAlign: 'right'},
      filterParams: AgGridSortFilterUtils.sortFilterColumn
    },
    {
      headerName: 'Has Manual Charges',
      field: 'hasmanualcharges',
      colId: 'hasmanualcharges',
      width: 90,
      cellRendererFramework: BooleanCheckComponent
    },
    {
      headerName: 'Schedule Name',
      field: 'schedulename',
      colId: 'schedulename',
      width: 90
    },
    {
      headerName: 'Modifiers',
      field: 'modifiers',
      colId: 'modifiers',
      width: 90
    },
    {
      headerName: 'Pick-Up',
      children: [
        {
          headerName: 'Actual PU',
          field: 'actualpickup',
          colId: 'actualpickup',
          width: 120
        },
        {
          headerName: 'PU Time',
          field: 'pickup',
          colId: 'puTime',
          width: 120
        },
        {
          headerName: 'Address',
          field: 'triplocationpickup.streetaddress',
          colId: 'puaddresss',
          width: 120
        },

        {
          headerName: 'City',
          field: 'triplocationpickup.city',
          colId: 'puCity',
          width: 120
        },
        {
          headerName: 'ZipCode',
          field: 'triplocationpickup.zip',
          colId: 'zipcodeP',
          width: 120
        },
        {
          headerName: 'Region PU',
          field: 'triplocationpickup.region',
          colId: 'triplocationpickup.region',
          width: 70
        }
      ]
    },
    {
      headerName: 'Drop-Off',
      children: [
        {
          headerName: 'Actual DO',
          field: 'actualdropoff',
          colId: 'actualdropoff',
          width: 120
        },
        {
          headerName: 'Address',
          field: 'triplocationdropoff.streetaddress',
          colId: 'doaddresss',
          width: 120
        },

        {
          headerName: 'City',
          field: 'triplocationdropoff.city',
          colId: 'doCity',
          width: 120
        },
        {
          headerName: 'ZipCode',
          field: 'triplocationdropoff.zip',
          colId: 'zipD',
          width: 120
        },
        {
          headerName: 'Region DO',
          field: 'triplocationdropoff.region',
          colId: 'triplocationdropoff.region',
          width: 70
        }
      ]
    }
  ]

  initGrid(gridName: GridOptions): void {
    gridName.columnDefs = this.createColumn();
    gridName.rowSelection = 'multiple';
    gridName.enableSorting = true;
    gridName.enableColResize = true;
    gridName.enableFilter = true;
    gridName.onSortChanged = () => this.afterSort();
    gridName.rowMultiSelectWithClick = true;

    gridName.onFilterChanged = (params) => {
      gridName.api.deselectAll();
      this.enableClearFilter = !params.api['filterManager'].advancedFilterPresent;
      this.getRowDisplayedRow(gridName);
    };
    gridName.rowClassRules = {
      'row-highlight': (params: any) => {
        return !!(params && params.data && params.data.ishighlighted);
      },
    };
    gridName.onGridReady = () => {
      gridName.api.setRowData([]);
    };

    gridName.onSelectionChanged = () => {
      const tripsForForm = this.getAllTripsIdSelected(gridName);
      this.service.actionGrid.next({
        isSubmit: true,
        action: AgGridActionsEnum.selectedRow,
        dataList: tripsForForm,
        showSetPlanTypeAndRegionButton: this.showSetPlanTypeAndRegionButton
      });
      this.toggleGridColumn(
        this.gridExportEncountersRejections, ['errordescription', 'errortype', 'errorcode', 'icn', 'filecount'],
        (this.selectedTab === TabsUnverifiedTripsEnum.Rejections)
      );
    };

    gridName.onRowDoubleClicked = (params) => {
      this.modalReservation.open();
      this.tripDataSelected = params.data;
    };
  }

  afterSort(): void {
    if (!this.clearSortSwitch) {
      this.clearSortSwitch = true;
    } else {
      this.enableClearSort = false;
    }
  }

  getAllTripsIdSelected(gridName: GridOptions): number[] {
    const data: number[] = [];
    this.tripData = [];
    gridName.api.forEachNodeAfterFilter((node: RowNode) => {
      if (node.isSelected()) {
        data.push(node.data.tripid);
        this.tripData.push(node.data);
      }
    });
    this.tripsArrayIds = data;
    return data;
  }

  getValidation(params: any): string {
    let ico = '';
    if (params.data.validations) {
      ico = 'fa-exclamation color-danger';
    }
    if (params.data.errorValid) {
      ico = 'fa-check color-success';
    }
    if (params.data.errorValid === false) {
      ico = 'fa-exclamation color-danger';
    }
    return `<i class="fa ${ico}" aria-hidden="true"></i>`;
  }

  amountCell = (params: any) => {
    return _currencyFormat(params.value ? params.value : 0);
  }


  validate(params): boolean {
    return !(params && params.data && !params.data.validations);
  }

  saveLayout(): void {
    if (this.gridExportEncountersRejections.columnApi.getColumnState().length > 0) {
      const MODULE_ACTION_ID = this.dataCurrentModule.actions.LayoutGrid.moduleactionid;
      const stringLayout = JSON.stringify(this.gridExportEncountersRejections.columnApi.getColumnState());
      const data = {moduleactionid: MODULE_ACTION_ID, config: stringLayout};

      this.observableList.push(
        this.tripService.postSaveLayout(data)
          .subscribe(
            () => this.toastrAlertHelper.success('Update your preferences to this grid', 'Success!'),
            () => this.toastrAlertHelper.error('error saving the layout', 'error')
          )
      );
    } else {
      this.toastrAlertHelper.info('There must be at least one column to save header settings.', 'Atention');
    }
  }

  clearFiltersExport() {
    this.gridExportEncountersRejections.api.setFilterModel(null);
    this.enableClearFilter = true;
  }

  clearSortExport() {
    this.gridExportEncountersRejections.api.setSortModel(null);
    this.enableClearSort = true;
  }

  dataGrid(data: any) {
    const filter = this.gridExportEncountersRejections.api.getFilterModel();
    const sort = this.gridExportEncountersRejections.api.getSortModel();

    if (this.gridExportEncountersRejections.api) {
      data.data ? this.gridExportEncountersRejections.api.setRowData(data.data) :
        this.gridExportEncountersRejections.api.setRowData(data);
      this.gridExportEncountersRejections.api.setFilterModel(filter);
      this.gridExportEncountersRejections.api.setSortModel(sort);
      this.getRowDisplayedRow(this.gridExportEncountersRejections);
      this.enableClearFilter = true;
      this.enableClearSort = true;
    }
  }

  getLayout(): void {
    this.observableList.push(
      this.tripService.getRoleActionByModule(this.dataCurrentModule.moduleid).subscribe(
        data => {
          data.forEach((val: any) => {
            if (val.action.description === 'LayoutGrid' && val.layout) {
              if (this.gridExportEncountersRejections && this.gridExportEncountersRejections.columnApi) {
                this.gridExportEncountersRejections.columnApi.setColumnState(JSON.parse(val.layout.config));
              }
            }
          });
        },
        (er) => this.objSweetAlert.captureException(er)
      )
    );
  }

  toggleGridColumn(gridName: GridOptions, nombreColumna: string[], visible = true): void {
    if (gridName.columnApi) {
      gridName.columnApi.setColumnsVisible(nombreColumna, visible);
    }
  }

  setGrid(gridName: GridOptions, arrayList: any[] = []): void {
    if (gridName.api) {
      gridName.api.setRowData(arrayList);
    }
  }

  generate837File(selectedForm: number, isSubmitions: boolean): void {
    const selectedTrips = this.trips(this.gridExportEncountersRejections);
    this._loading.show('Generating File');
    if (selectedTrips.length > 0 && selectedForm) {
      this.observableList.push(
        this.service.generateFile837({formId: selectedForm, trips: selectedTrips, isResubmission: isSubmitions})
        .finally(() => this._loading.hiden())
          .subscribe({
            next: (data: any) => {
              if (data) {
                _downloadFile(data.blob(), data.headers.get('X-Custom-Header-FileName'));
              }
            },
            error: (error: any) => {
              if (error && error.headers) {
                this.objSweetAlert.createCustomAlert({
                  title: 'Error generating file',
                  text: error.headers.get('X-Custom-Header-FileName'),
                  type: 'error',
                  showCancelButton: true,
                  confirmButtonText: 'Close',
                  cancelButtonText: 'Force Download'
                }).then((result) => {
                  const { dismiss } = result;
                  if (dismiss === Swal.DismissReason.cancel) {
                    this.forceGenerate837File(selectedForm, selectedTrips, isSubmitions);
                  }
                });
              }
            }
          })
      );
    }
  }

  private forceGenerate837File(formId: number, trips: number[], isResubmission: boolean) {
    this._loading.show('Generating File');
    this.observableList.push(
      this.service.generateFile837({ formId, trips, isResubmission, force: true })
        .finally(() => this._loading.hiden())
        .subscribe({
          next: (data) => {
            if (data) {
              _downloadFile(data.blob(), data.headers.get('X-Custom-Header-FileName'));
            }
          },
          error: (error) => {
            if (error && error.headers) {
              this.objSweetAlert.createCustomAlert({
                title: 'Error generating file',
                text: error.headers.get('X-Custom-Header-FileName'),
                type: 'error',
              })
            }
          }
        })
    );
  }

  trips(gridName: GridOptions): number[] {
    const trips = [];
    gridName.api.getSelectedNodes().forEach((data) => {
      trips.push(data.data.tripid);
    });
    return trips;
  }

  getRowDisplayedRow(nameGrid: GridOptions) {
    this.service.actionGrid.next({
      isSubmit: true, action: AgGridActionsEnum.rowCount,
      dataList: [{rowCount: nameGrid.api.getDisplayedRowCount()}]
    });
  }

  private initLayoutMenu() {
    this.observableList.push(this.layoutStore.follow(this.actionsList$, () => ({
      grid: this.gridExportEncountersRejections,
      moduleActionId: moduleActionIdOf(this.dataCurrentModule, 'LayoutGrid'),
      title: 'Encounters',
      buttonClass: 'm-btn m-btn-secundary m-btn-circle m-btn-circle-small-medium margin margin-r-4 margin-t-15'
    })));
  }

  ngOnDestroy(): void {
    if (this.observableList.length) {
      this.observableList.forEach(row => row.unsubscribe());
    }
  }

  setNonDuplicate(details) {
    this.objSweetAlert
      .createCustomAlert({
        title: 'Are you sure?',
        text: 'You will not be able to revert this!',
        type: 'warning',
        showCancelButton: true,
      })
      .then((result) => {
        if (result && result.value && this.gridSelected.length) {
          this._loading.show();
          this.service.setNonDuplicate(this.gridSelected)
          .finally(() => {
            this._loading.hiden();
          })
          .subscribe({
            next: () => {
              this.objSweetAlert.createCustomAlert({
                title: 'Success',
                text: 'Non duplicate has changed status',
                type: 'success',
              });
              this.loadDataToExport(details);
            },
            error: (err) => {
              this.objSweetAlert.captureException(err);
            },
          });
        }
      });
  }

  loadDataToExport(details) {
    const { begin, end, firstPayorSelectedList, showqty, showsent, isResubmission } = details.shift();
    this.service.dataToExportTripsECM(begin, end, firstPayorSelectedList, showqty, showsent, isResubmission)
      .finally(() => this._loading.hiden())
      .subscribe((data) => {
        if (data) {
          this.service.actionGrid.next({
            isSubmit: true,
            action: AgGridActionsEnum.LoadData,
            dataList: data,
            selectedTab: 1
          });
          this.dataGrid(data);
        }
      },
      (error) => {
        this._loading.hiden();
        this.toastrAlertHelper.error(error.message);
      });
  }

  getReservationGrid() {
    this.observableList.push(
      this.service.changePlanType$.pipe(
        switchMap(value => {
          if (value && this.gridExportEncountersRejections && this.gridExportEncountersRejections.api.getSelectedRows().length) {
            const selectedRows = this.gridExportEncountersRejections.api.getSelectedRows();
            const reservationList = selectedRows.map((row: any) => row.reservationid as number);
            if (reservationList && reservationList.length) {
              this._loading.show();
              return this.service.changePlanTypeService(reservationList).pipe(
                tap(() => {
                  this.objSweetAlert.createCustomAlert({
                    title: 'Success',
                    text: 'Successful Type Change',
                    type: 'success',
                  }).then(() => {
                    this.service.setChangePlanType(false);
                  });
                }),
                tap({
                  error: (err) => {
                    this.objSweetAlert.captureException(err);
                  }
                }),
                finalize(() => {
                  this._loading.hiden();
                })
              );
            }
          }
          return [];
        })
      ).subscribe()
    );
  }

  setReservationPlanTypeAndRegion(): void {
    const selectedTrips = this.trips(this.gridExportEncountersRejections);
    if (selectedTrips && selectedTrips.length) {
      this._loading.show();
      this.observableList.push(
        this.planService.setReservationPlanTypeAndRegion(selectedTrips)
          .finally(() => this._loading.hiden())
          .subscribe({
            next: (response) => {
              this.objSweetAlert.createCustomAlert({
                title: 'Success',
                text: response.message,
                type: 'success',
              });
            },
            error: (err) => {
              this.objSweetAlert.captureException(err);
            },
          }),
      );
    } else {
      this.objSweetAlert.createCustomAlert({
        title: 'Atention',
        text: 'You must select at least one trip',
        type: 'warning',
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/Encounters/encounters-grid/encounters-grid.component.ts